import { Injectable, NgModule } from '@angular/core';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class ExportService {
  private copyStyles = [
    'color',
    'backgroundColor',
    'fontSize',
    'fontWeight',
    'textAlign',
    'textDecoration',
    'borderTopStyle',
    'borderRightStyle',
    'borderBottomStyle',
    'borderLeftStyle',
    'borderTopColor',
    'borderRightColor',
    'borderBottomColor',
    'borderLeftColor',
  ];

  constructor() { }

  /**
   *
   * @param tableName id of table to be exported
   * @param worksheet Name the Excel Worksheet
   * @param workbook Name Workbook
   * @param margins optional top, right, bottom, and left margins for export print in inches.
   */

  toExcel(tableName: string, worksheet: string, workbook: string, margins: string[] = []): void {
    const table = document.getElementById(tableName);
    const elementsWithClassAttribute = table.querySelectorAll('[class]');

    for (let i = 0; i < elementsWithClassAttribute.length; i++) {
      const element = elementsWithClassAttribute[i] as HTMLElement;
      const styles = window.getComputedStyle(element) as CSSStyleDeclaration;

      element.style.borderTopWidth = '0.1pt';
      element.style.borderRightWidth = '0.1pt';
      element.style.borderBottomWidth = '0.1pt';
      element.style.borderLeftWidth = '0.1pt';

      for (let e = 0; e < this.copyStyles.length; e++) {
        const style = this.copyStyles[e];
        if (styles[style]) {
          element.style[style] = styles[style];
        }
      }
    }

    const clnTable = table.cloneNode(true) as HTMLElement;
    const removeNodes = clnTable.getElementsByClassName('export-ignore');
    const inputNodes = clnTable.getElementsByTagName('input');
    const bgAsTextColor = clnTable.getElementsByClassName('exoprt-bg-as-text');

    while (removeNodes[0]) {
      removeNodes[0].parentNode.removeChild(removeNodes[0]);
    }

    for (let i = 0; i < inputNodes.length; i++) {
      const textNode = document.createTextNode(inputNodes[i].value);
      inputNodes[i].parentNode.replaceChild(textNode, inputNodes[i]);
    }

    for (let i = 0; i < bgAsTextColor.length; i++) {
      const element = bgAsTextColor[i] as HTMLElement;
      element.style.color = element.style.backgroundColor;
    }

    const blob = new Blob([this.getTemplate(clnTable, worksheet, margins)], {
      type: 'application/vdn.openxmlformats-officedocuments.spreadsheetml.sheet;charset=utf-8'
    });

    saveAs(blob, `${workbook}.xls`);
  }

  private getTemplate(table: HTMLElement, worksheet: string, margins: string[]): string {
    return `<html
                  xmlns:o="urn:schemas-microsoft-com:office:office"
                  xmlns:x="urn:schemas-microsoft-com:office:excel"
                  xmlns="http://www.w3.org/TR/REC-html40"
                  >
              <head>
              <style type="text/css">
                @page{
                  margin: ${margins[0] || '.75in'}
                          ${margins[1] || '.25in'}
                          ${margins[2] || '.75in'}
                          ${margins[3] || '.25in'};
                  mso-header-margin: .5in;
                  mso-footer-margin: .5in;
                  mso-page-orientation: landscape;
                }
                td {
                  vertical-align: top;
                }
              </style>
              <!--[if gte mso 9]>
                <xml>
                  <x:ExcelWorkbook>
                    <x:ExcelWorksheets>
                      <x:ExcelWorksheet>
                      <x:Name>${worksheet}</x:Name>
                      <x:WorksheetOptions>
                        <x:FitToPage/>
                        <x:PageSetup>
                          <x:Layout x:Orientation="Landscape"/>
                        </x:PageSetup>
                        <x:Print>
                          <x:FitWidth>1</x:FitWidth>
                          <x:FitHeight>0</x:FitHeight>
                          <x:ValidPrinterInfo/>
                        </x:Print>
                      </x:WorksheetOptions>
                      </x:ExcelWorksheet>
                    </x:ExcelWorksheets>
                  </x:ExcelWorkbook>
                </xml>
              <![endif]-->
              </head>
              <body style="background-color: white;">
                ${table.innerHTML}
              </body>
            </html>`;
  }

}

@NgModule({
  imports: [],
  providers: [ExportService]
})
export class ExportToExcelModule { }
